import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * Scrolls the window to top on every route change so navigating to a new
 * page lands at the top, not at whatever scroll position the previous page
 * was at. Uses `behavior: 'instant'` to bypass the global
 * `scroll-behavior: smooth` CSS — otherwise route changes animate the
 * entire page scroll, which feels broken.
 *
 * Hash links (e.g. `/#pricing`) are left alone so the browser's native
 * anchor scroll still works.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
